// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__4yzkm","loader--stats":"Loader_loader--stats__-nj1M"};